export class Content {
  id: number;
  title: string;
  authors: string[];
  subtitle: string;
  urlViewer: string;
  urlDownload: string;
  authorsNames: string;
  type: string;
  hasGrading: boolean;
  constructor(data: any) {
    this.id = data.id;
    this.title = data.title;
    this.hasGrading = data.hasGrading;
  }
}